import { Tooltip, copyTextToClipboard } from '@systemeio/ui'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { CopyIcon } from '@systemeio/ui/icons'

interface CopyToClipboardButtonProps {
  text: Parameters<typeof copyTextToClipboard>[0]
  className?: string
  onCopy?: () => void
  disabled?: boolean
}

export function CopyToClipboardButton({
  text,
  className,
  onCopy,
  disabled,
}: CopyToClipboardButtonProps) {
  const { t } = useLocoTranslation()
  return (
    <Tooltip disabled={disabled} label={t('global.copy')} className={className}>
      <button
        type={'button'}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            e.currentTarget.click()
          }
        }}
        onClick={async () => {
          await copyTextToClipboard(text, t('global.copy_clipboard'))
          onCopy?.()
        }}
        disabled={disabled}
        className="group outline-hidden"
      >
        <CopyIcon
          className={twMerge(
            'h-[16px] w-[16px]',
            !disabled &&
              'group-focus-visible:fill-brand-primary hover:fill-brand-primary main-transition-colors cursor-pointer',
          )}
        />
      </button>
    </Tooltip>
  )
}
